import { render, staticRenderFns } from "./HoldingsStatusIndicator.vue?vue&type=template&id=b9dec780&"
import script from "./HoldingsStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./HoldingsStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports